import { ChangeDetectionStrategy, Component, QueryList, ViewChildren, computed, signal } from '@angular/core';
import { AddressSelector, AddressValue } from '../../../../shared/components/address-selector/address-selector';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-guia',
  imports: [AddressSelector, FormsModule],
  templateUrl: './guia.html',
  styleUrl: './guia.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Guia {

  @ViewChildren(AddressSelector)
  private readonly addressSelectors?: QueryList<AddressSelector>;

  constructor(private http: HttpClient) {

  }
  waypoints = signal<AddressValue[]>([]);

  add() {
    this.waypoints.update(wps => [...wps, { direccion: '', codigoPostal: '' }]);
    // Wait for the new row/component to render, then focus its autocomplete control.
    setTimeout(() => this.addressSelectors?.last?.focus(), 0);
  }

  calculateRoute() {
    let url = `${environment.apiUrl}/api/routes/optimized-route`;
    this.http.post(url, this.waypoints().map(x => x.direccion)).subscribe({
      next: (response: any) => {
        this.url.set(response.url);
        this.addresses.set(response.waypoints);
        console.log('Route calculated successfully:', response);
      }
    });
  }
  addressSelected(value: AddressValue, index: number): void {
    if (document.getElementById(`address-${index + 1}`)?.innerText == "")
      return;

    this.add();
  }

  url = signal('');
  addresses = signal<string[]>([]);

  updateAddress(index: number, value: AddressValue | null): void {
    this.waypoints.update(wps =>
      wps.map((wp, i) => (i === index ? (value ?? { direccion: '', codigoPostal: '' }) : wp))
    );


  }

}
